import routes from "~/configs";
import EmptyLayout from "~/Layouts/EmptyLayout";
import AddPoint from "~/page/AddPoint";
import History from "~/page/History";
import Login from "~/page/Login/Login";
import NavigationPage from "~/page/NavigationPage";
import AdminDashboardPage from "~/page/AdminDashboardPage";
import VehicleDetailPage from "~/page/VehicleDetailPage/VehicleDetailPage";
import WashUploadPage from "~/page/WashUploadPage";
import DriverHomePage from "~/page/DriverHomePage";
import CheckInUploadPage from "~/page/CheckInUploadPage";
import NotFoundPage from "~/page/NotFoundPage";
import GioVang from "~/page/GioVang";
import Spinner from "~/page/Spinner";
import RevenueAppPage from "~/revenue/RevenueAppPage";

export const publicRouters = [
  // customer
  {
    component: AddPoint,
    path: routes.home,
    layout: EmptyLayout,
  },
  {
    component: History,
    path: routes.history,
    layout: EmptyLayout,
  },
  // admin
  {
    component: AdminDashboardPage,
    path: routes.admin,
    layout: EmptyLayout,
  },
  {
    component: RevenueAppPage,
    path: "/revenue/*",
    layout: EmptyLayout,
  },
  {
    component: Login,
    path: routes.login,
    layout: EmptyLayout,
  },

  // driver
  
  {
    component: DriverHomePage,
    path: routes.driverDetail,
    layout: EmptyLayout,
  },
  {
    component: CheckInUploadPage,
    path: routes.driverCheckIn,
    layout: EmptyLayout,
  },
  {
    component: WashUploadPage,
    path: routes.driverWash,
    layout: EmptyLayout,
  },
  {
    component: VehicleDetailPage,
    path: routes.driverHistory,
    layout: EmptyLayout,
  },

  // dev
  
  {
    component: NavigationPage,
    path: routes.link,
    layout: EmptyLayout,
  },
  {
    component: NotFoundPage,
    path: routes.notFound,
    layout: EmptyLayout,
  },

  // gio vang
  {
    component: GioVang,
    path: routes.gioVang,
    layout: EmptyLayout,
  },
  {
    component: Spinner,
    path: routes.vongquay,
    layout: EmptyLayout,
  },
];